export { default } from "ember-inflector/helpers/pluralize";
